import { useEffect, useState } from 'react'
import agent from '../api/agent'
import type { LegalTextDto } from '../models/legalText'

export function useLegalText (key: string) {
  const [text, setText] = useState<LegalTextDto | null>(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    if (!key) return

    const loadText = async () => {
      setLoading(true)
      setError(null)
      try {
        const result = await agent.LegalText.getByKey(key)
        setText(result)
      } catch (err: any) {
        setError(err.message || 'Failed to load legal text')
        setText(null)
      } finally {
        setLoading(false)
      }
    }

    loadText()
  }, [key])

  return { text, loading, error }
}
